export default {
    id: 1,
    name: 'test',
    image: '',
    blocks: []
}
